/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Diff_RemovedInputs */

const cs_ebr_diff_removed = /** @type {(inputs: Ebr_Diff_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`odebráno`)
};

const en_ebr_diff_removed = /** @type {(inputs: Ebr_Diff_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`removed`)
};

/**
* | output |
* | --- |
* | "removed" |
*
* @param {Ebr_Diff_RemovedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_diff_removed = /** @type {((inputs?: Ebr_Diff_RemovedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Diff_RemovedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_diff_removed(inputs)
	return cs_ebr_diff_removed(inputs)
});